import { UnitPriceUI } from "./UnitPriceUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";

export function UnitPrice({ product }: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);

  const activeVariant = ensureIsActiveVariant(variant);

  if (!activeVariant) return null;

  const { pricePerUnit } = activeVariant;

  if (!pricePerUnit) return null;

  const { quantity, unitOfMeasure, display } = pricePerUnit;

  return (
    <UnitPriceUI
      displayPrice={display}
      quantity={quantity}
      unitOfMeasure={unitOfMeasure}
    />
  );
}
